fx.ns("shared.popups", class ServerError extends shared.popups.BasePersonPopup{
    
    constructor(data)
    {
        super(data, fx.get("assets").personNotHappy );
        this.contentWidth = 500;
        this.contentHeight = 250;
    }

    create()
    {
        super.create();
 
        this.addChild(new fx.components.Text({text:fx.text("Une erreur est arrivée"), className:"title"}));
        this.addChild(new fx.components.Text({text:fx.text("Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>"), className:"text"}));

        this.addFooterChild("close");
    }

    onClose()
    {
        super.onClose();
        this.data.event("reload-page");
    }


});